import { steps } from '@/lib/chirp-data'

export function GetStarted() {
  return (
    <section id="get-started" className="border-b border-border/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4">
        <div className="max-w-2xl">
          <span className="font-mono text-sm text-primary">// getting started</span>
          <h2 className="mt-3 text-balance text-3xl font-bold tracking-tight sm:text-4xl">
            From download to first channel in four steps
          </h2>
          <p className="mt-4 text-pretty leading-relaxed text-muted-foreground">
            New to NewChirp? The workflow is always the same regardless of which radio you own. Always
            download an image from your radio first so you have a backup.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 md:grid-cols-2">
          {steps.map((step) => (
            <li
              key={step.number}
              className="relative rounded-xl border border-border bg-card p-6"
            >
              <span className="font-mono text-sm font-bold text-primary">{step.number}</span>
              <h3 className="mt-2 text-lg font-semibold">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {step.description}
              </p>
            </li>
          ))}
        </ol>

        <div className="mt-8 rounded-xl border border-primary/30 bg-primary/5 p-5">
          <p className="text-sm leading-relaxed text-muted-foreground">
            <span className="font-semibold text-primary">Tip:</span> Never upload an image to a radio
            it did not come from. Always keep the original download as a backup before you make
            changes.
          </p>
        </div>
      </div>
    </section>
  )
}
